module.exports = __webpack_public_path__ + "img/shopping_application_202604-4.a575fbe0.jpg";